/** 目標/計畫/每期保費暨配置比例/繳別變更 */
import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/A1';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 取得繳別下拉式選單 */
export function getMopInfoA1() {
    return get(`${url}/mopInfo`);
};
/** 取得條款說明 */
export function getAgreeTermsA1() {
    return get(`${url}/getAgreeTerms`);
};

/** 條款同意 */
export function postAgreeA1() {
    return post(`${url}/agree`);
};

/** 取得A1資料 取得先前目標/計畫/每期保費暨配置比例/繳別變更記錄 */
export function getInfoA1() {
    return get(`${url}/info`);
};

/** 取得投資標的公司及投資標的名稱下拉式選單 */
export function getFundBankInfoA1() {
    return get(`${url}/fundBankInfo`);
}

/** A1 變更送出 */
export function submitA1(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
};
